import { SignoutOutlineIcon } from '@carboncopyco/icons';
import { ConfirmAlert, TextBase } from '@carboncopyco/ui';

export interface WorkspaceLeaveModalProps {
  /** modal's visible state */
  show: boolean;
  /** handler to be called upon closing the modal */
  onClose: () => void;
  /** logic related to leaving a workspace */
  leaveWorkspace: () => void;
}

export const workspaceModalLabels = {
  archive: 'Archiving the workspace will also deactivate all shared links.',
  leave: 'Leaving this workspace will deactivate your access to its assets.',
  leaveLastMember:
    'As you are the only member in this workspace, the workspace and its shared links would be archived.',
};

export const WorkspaceLeaveModal = ({
  show,
  onClose,
  leaveWorkspace,
}: WorkspaceLeaveModalProps) => {
  return (
    <ConfirmAlert
      title="Leave workspace"
      containerClass="w-ds-516"
      danger
      yesIcon={<SignoutOutlineIcon />}
      yesLabel="Leave workspace"
      show={show}
      onConfirm={leaveWorkspace}
      onClose={onClose}
    >
      <div className=" flex flex-col gap-1 pt-3">
        <TextBase
          label="Are you sure?"
          color="text-ds-natural-600"
        />
        <TextBase
          label={workspaceModalLabels.leave}
          color="text-ds-natural-600"
        />
      </div>
    </ConfirmAlert>
  );
};
